import type { UpdateActionUpdateMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateActionUpdateDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { UpdateActionUpdateInput } from './types';

export const useUpdateActionUpdate = createMutationHook({
  name: 'updateActionUpdate',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.action.updates.update.mutationOptions({ onSuccess }),
  mapInput: (variables: UpdateActionUpdateInput): UpdateActionUpdateInput => ({
    Id: variables.Id,
    ParentActionId: variables.ParentActionId,
    Title: variables.Title,
    Description: variables.Description,
    CustomAttributeData: variables.CustomAttributeData ?? null,
    OriginalTimestamp: variables.OriginalTimestamp,
  }),
  invalidate: (trpc) => [
    trpc.frontend.action.updates.getActionUpdatesByParentActionId.queryKey(),
    trpc.frontend.action.updates.getActionUpdateById.queryKey(),
    // COI-889: the Actions register's latest-update and update-count columns
    // read `actionUpdateSummary`.
    trpc.frontend.action.register.queryKey(),
  ],
  mapResponse: (): UpdateActionUpdateMutation => ({
    update_action_update: {
      __typename: 'action_update_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateActionUpdateDocument,
  graphqlVariables: (variables: UpdateActionUpdateInput) => ({
    ...variables,
  }),
  validateGraphqlResponse: (data) => {
    if (data.update_action_update?.affected_rows !== 1) {
      throw new Error(
        'Records not updated. Record may have been updated by another user'
      );
    }
  },
  evictFields: ['action_update', 'action_update_aggregate'],
});
